import { PageDetails } from '../../../../types/Performance/MyReview/myReviewTypes'
import {
  ObservationPayload,
  PerformanceRating,
  GetObservationsApiProps,
  getAllObservationsApiResponse,
  Observation,
} from '../../../../types/Performance/Observation/observationTypes'
import { ActiveEmployee } from '../../../../types/Performance/PipList/pipListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  myReviewApiConfig,
  observationApiConfig,
} from '../../apiList'

const addObservation = async (payload: ObservationPayload): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: observationApiConfig.addObservation,
    method: AllowedHttpMethods.post,
    data: payload,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const uploadCandidateObservation = async (
  personId: number,
  file: File,
): Promise<void> => {
  const formData = new FormData()
  formData.append('file', file)

  const requestConfig = getAuthenticatedRequestConfig({
    url: observationApiConfig.uploadCandidateObservation,
    method: AllowedHttpMethods.post,
    data: formData,
    params: {
      personId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getObservationRatingDetails = async (): Promise<PageDetails> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: myReviewApiConfig.getEmployeePerformanceReview,
    method: AllowedHttpMethods.get,
    params: {
      pageName: 'reviews',
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getActiveEmployees = async (): Promise<ActiveEmployee[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: observationApiConfig.activeEmployee,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getPerformanceRatings = async (): Promise<PerformanceRating[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: observationApiConfig.getPerformanceRatings,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getAllObservations = async (
  props: GetObservationsApiProps,
): Promise<getAllObservationsApiResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: observationApiConfig.getAllObservations,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex,
      startIndex: props.startIndex,
      listFlag: props.listFlag,
      multipleSearch: props.multipleSearch,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const deleteObservation = async (observationId: number): Promise<void> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: `${observationApiConfig.deleteObservation}/${observationId}`,
    method: AllowedHttpMethods.delete,
  })

  await useAxios(requestConfig)
}
const updateObservation = async (
  payload: Observation,
): Promise<Observation> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: observationApiConfig.updateObservation,
    method: AllowedHttpMethods.put, // or patch
    data: payload,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const downloadObservationFile = async (fileName: string): Promise<Blob> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: observationApiConfig.downloadObservationFile,
    method: AllowedHttpMethods.get,
    params: {
      fileName,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const exportObservation = async (props: {
  searchInput: string
  observationType: string
}): Promise<Blob> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: observationApiConfig.exportObservation,
    method: AllowedHttpMethods.get,
    params: {
      multipleSearch: props.searchInput,
      listFlag: props.observationType,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}
export const observationApi = {
  addObservation,
  uploadCandidateObservation,
  getObservationRatingDetails,
  getActiveEmployees,
  getPerformanceRatings,
  getAllObservations,
  deleteObservation,
  updateObservation,
  downloadObservationFile,
  exportObservation,
}
